<nav class="navbar navbar-expand-lg shadow py-2 fixed-top" [scrollTop]="scr()"> 
    <div class="container-fluid">
      <a class="navbar-brand" routerLink="/home" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
        <img src="assets/images/logo-removebg-preview.png" height="50" class="d-inline-block align-top" alt="Hurghada Radio Logo">
        <!-- <span> @if (isArabic) { راديو الغردقة  } @else { Hurghada Radio } </span> -->
      </a>
      <button 
        class="navbar-toggler" 
        type="button" 
        data-bs-toggle="collapse" 
        data-bs-target="#navbarSupportedContent" 
        aria-controls="navbarSupportedContent" 
        aria-expanded="false" 
        aria-label="Toggle navigation"
        >
        <i class="fa-solid fa-bars"></i> 
      </button>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav ms-auto my-1 mb-lg-0" [ngClass]="{'m-auto': isArabic}">

          <li class="nav-item me-3" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
            <a class="nav-link py-1 px-3" routerLink="home" routerLinkActive="router-link-active">
              @if (isArabic) { الرئيسية } @else { Home }
            </a>
          </li>

          <li class="nav-item me-3" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
            <a class="nav-link py-1 px-3" routerLink="about" routerLinkActive="router-link-active">
              @if (isArabic) { عنا } @else { About Us}
            </a> 
          </li>

          <li class="nav-item me-3" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
            <a class="nav-link py-1 px-3" routerLink="contact" routerLinkActive="router-link-active">
              @if (isArabic) { تواصل معنا } @else { Contact }
            </a>
          </li>

          <li class="nav-item me-3" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
            <a class="nav-link py-1 px-3" routerLink="news" routerLinkActive="router-link-active">
              @if (isArabic) { أحدث الاخبار } @else { last news }
            </a>
          </li>

          <!-- <li class="nav-item me-3" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
            <a class="nav-link py-1 px-3" routerLink="chat" routerLinkActive="router-link-active">
              @if (isArabic) { دردشة مباشرة } @else { Live Chat } 
            </a>
          </li> -->

          <li class="nav-item me-3" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
            <a class="nav-link py-1 px-3" routerLink="programs" routerLinkActive="router-link-active">
              @if (isArabic) { جدول البرامج } @else { Programs }
            </a>
          </li>

        </ul>

        <ul class="navbar-nav ms-auto my-1 mb-lg-0 text-center" [ngClass]="{'m-auto': isArabic}">
          <li class="text-center" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
            <button class="selectLang p-1 w-100 px-4" (click)="changeLangBtn()">
              @if (isArabic) { English } @else { العربية }
            </button>
          </li>
          <li class="text-center ms-2 icons">
            @for (item of socials; track $index) {
                <a [href]="item.link" target="_blank" class="p-1 me-2 fs-5 scale"> <i [class]="item.icon"></i> </a>
            }
          </li> 
          <li class="text-center ms-2 nav-auth">
            <div class="d-flex flex-column flex-md-row align-items-center gap-2 auth-buttons">
              @if (isLogin) {
                <a class="btn nav-pill btn-dashboard"
                   routerLink="/control-news"
                   routerLinkActive="router-link-active">
                  <i class="fa-solid fa-gauge-high ms-2"></i>
                  @if (isArabic) { لوحة التحكم } @else { Dashboard }
                </a>
                <button class="btn nav-pill btn-logout" (click)="logout()">
                  <i class="fa-solid fa-power-off ms-2"></i>
                  @if (isArabic) { تسجيل الخروج } @else { Logout }
                </button>
              }
              @else {
                <button class="btn nav-pill btn-login-cta"
                        type="button"
                        data-bs-toggle="modal"
                        data-bs-target="#loginModal">
                  <span class="pulse-dot"></span>
                  <i class="fa-solid fa-arrow-right-to-bracket ms-2"></i>
                  @if (isArabic) { تسجيل الدخول } @else { Login }
                </button>
              }
            </div>
          </li>
          <li class="text-center ms-2 mt-2 d-md-none acme">
            Made With <i class="fa-solid fa-heart text-danger"></i> By <a href="https://acmecode-eg.com/" target="_blank"> AcmeCode </a>
          </li> 
        </ul>
        
      </div>
    </div>
  </nav>
  
  